import { ScopedCssBaselineProps, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import colors from "common/styles/colors";
import clsx from "clsx";
import { ComponentWithChildren } from "../../../../../common/types";

const useStyles = makeStyles({
  paragraph: {
    fontWeight: 400,
    fontSize: "18px",
    color: colors.darkGrey1,
    textAlign: "center",
    lineHeight: "32px",
    maxWidth: "384px",
    ["@media (max-width:600px)"]: {
      maxWidth: "80%",
      fontSize: "16px",
      lineHeight: "28px"
    }
  }
});

type Props = {
  className?: string;
  sx?: ScopedCssBaselineProps;
};

export const Paragraph: ComponentWithChildren<Props> = ({ children, className, sx }) => {
  const styles = useStyles();

  return (
    <Typography sx={sx} className={clsx(styles.paragraph, className && className)} data-testid="paragraph">
      {children}
    </Typography>
  );
};
